import {type BannerAssessment} from '../assessments-banner/assessments-banner-card.react-component';

/**
 * Selects a single assessment to recommend for the given course topic id.
 * Filters out inactive Assessments and picks the first match
 */
export function selectRecommendedAssessment(
    all: BannerAssessment[],
    courseTopicId: string | null,
): BannerAssessment | null {
    if (!courseTopicId) {
        return null;
    }
    return (
        all.find(
            (assessment) =>
                assessment.isActive &&
                assessment.topics?.some((topic) => topic?.id === courseTopicId),
        ) ?? null
    );
}

/**
 * Helper method to pull in highest weighted domain id if present, for event tracking purposes
 */
export function selectPrimaryDomainId(assessment: BannerAssessment): string | null {
    const domains = (assessment.domains ?? []).filter((domain) => domain != null);
    if (domains.length === 0) {
        return null;
    }
    const highestWeighted = domains.reduce((best, domain) =>
        (domain.weight ?? -Infinity) > (best.weight ?? -Infinity) ? domain : best,
    );
    return highestWeighted.id;
}
